import _map from 'lodash/map';
import _isArray from 'lodash/isArray';
import QueryString from 'qs';

const formatFilter = facetFilters => {
    const filters = _map(facetFilters, f => {
        if(_isArray(f)) {
            return `[${f.map(fi => `"${fi}"`).join(",")}]`;
        }
        return `"${f}"`;
    });
    return `[${filters.join(",")}]`;
};

export const formatRequest = params => {
    params.facets = JSON.stringify(params.facets);
    params.facetFilters = formatFilter(params.facetFilters);
    params = QueryString.stringify(params, {
        arrayFormat: 'comma'
    });

    return params;
};